import React from 'react';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import ProblemSection from '@/components/ProblemSection';
import FeaturesPreview from '@/components/FeaturesPreview';
import RevenueSection from '@/components/RevenueSection';
import MultiChannelSection from '@/components/MultiChannelSection';
import ROICalculator from '@/components/ROICalculator';
import HowItWorksPreview from '@/components/HowItWorksPreview';
import IntegrationsPreview from '@/components/IntegrationsPreview';
import CTASection from '@/components/CTASection';
import Footer from '@/components/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#FDFDFD]" data-testid="landing-page">
      <Navbar />
      <main>
        <HeroSection />
        <ProblemSection />
        <FeaturesPreview />
        <ROICalculator />
        <MultiChannelSection />
        <RevenueSection />
        <HowItWorksPreview />
        <IntegrationsPreview />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
